function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function s4() {
  return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
}

export function guid() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
var class2type = {};
var toString = Object.prototype.toString;
'Boolean Number String Function Array Date RegExp Object Error'.replace(/\w+/g, function (name) {
  class2type['[object ' + name + ']'] = name.toLowerCase();
  return name;
});
export function type(obj) {
  if (obj == null) {
    return String(obj);
  }

  if (_typeof(obj) === 'object' || typeof obj === 'function') {
    return class2type[toString.call(obj)] || 'object';
  }

  return _typeof(obj);
}
var rvalue = /^(?:number|string|boolean|regexp)$/;
export function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
export function deepClone(obj) {
  if (obj == null || _typeof(obj) !== 'object') {
    return obj;
  }

  var t = type(obj);

  if (rvalue.test(t)) {
    return obj.valueOf();
  }

  if (t === 'date') {
    return new Date(obj.getTime());
  }

  if (t === 'error') {
    return new Error(obj.message);
  }

  var ret = {};

  if (t === 'array') {
    return obj.map(function (item) {
      return deepClone(item);
    });
  }

  Object.keys(obj).forEach(function (key) {
    ret[key] = deepClone(obj[key]);
  });
  return ret;
}
export function classnames() {
  var classes = [];

  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  var _loop = function _loop() {
    var cls = _classNames[_i];

    if (!cls) {
      return "continue";
    }

    if (typeof cls === 'string') {
      classes.push(cls);
    } else if (Array.isArray(cls)) {
      cls.forEach(function (item) {
        if (item) {
          classes.push(item);
        }
      });
    } else if (_typeof(cls) === 'object' && cls) {
      Object.keys(cls).forEach(function (key) {
        if (cls[key]) {
          classes.push(key);
        }
      });
    }
  };

  for (var _i = 0, _classNames = classNames; _i < _classNames.length; _i++) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return classes.join(' ');
}
export function equal(first, second) {
  if (first === second) {
    return first !== 0 || second !== 0 || 1 / Number(first) === 1 / Number(second);
  }

  return first !== first && second !== second;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;

function objectEqual(first, second) {
  var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (equal(first, second)) {
    return true;
  }

  if (_typeof(first) !== 'object' || _typeof(second) !== 'object') {
    return false;
  }

  if (first == null || second == null) {
    return false;
  }

  var firstKeys = Object.keys(first);
  var secondKeys = Object.keys(second);

  if (firstKeys.length !== secondKeys.length) {
    return false;
  }

  return firstKeys.every(function (item) {
    if (!hasOwnProperty.call(second, item)) {
      return false;
    }

    var fv = first[item];
    var sv = second[item];

    if (deep) {
      return objectEqual(fv, sv, deep);
    }

    return equal(fv, sv);
  });
}

export function shallowEqual(first, second) {
  return objectEqual(first, second, false);
}
export function deepEqual(first, second) {
  return objectEqual(first, second, true);
}
export function throttle(fn, delay) {
  var timer = null;
  var remaining = 0;
  var previous = +new Date();
  var currentArgs;
  return function () {
    var now = +new Date();
    remaining = now - previous;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    currentArgs = args;

    if (remaining >= delay) {
      if (timer) {
        clearTimeout(timer);
      }

      fn.apply(null, currentArgs);
      previous = now;
    } else if (!timer) {
      var timerHandler = function timerHandler() {
        fn.apply(null, currentArgs);
        previous = +new Date();
      };

      timer = setTimeout(timerHandler, delay - remaining);
    }
  };
}
export function debounce(func, delay, options) {
  var lastArgs;
  var lastThis;
  var maxWait;
  var result;
  var timerId;
  var lastCallTime;
  var lastInvokeTime = 0;
  var leading = false;
  var maxing = false;
  var trailing = true;

  if (typeof func !== 'function') {
    throw new TypeError('首个参数必须是函数');
  }

  var wait = Number(delay) || 0;

  if (options) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;

    if (maxing) {
      maxWait = Math.max(Number(options.maxWait) || 0, wait);
    }

    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs;
    var thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args || []);
    return result;
  }

  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime;
    var timeSinceLastInvoke = time - lastInvokeTime;
    var timeWaiting = wait - timeSinceLastCall;
    return maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime;
    var timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = Date.now();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }

    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId != null) {
      clearTimeout(timerId);
    }

    lastInvokeTime = lastCallTime = 0;
    timerId = undefined;
    lastArgs = lastThis = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Date.now());
  }

  function debounced(context) {
    var time = Date.now();
    var isInvoking = shouldInvoke(time);

    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    lastArgs = args;
    lastThis = context;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
export function tuple() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return args;
}
export function pick(obj, keys) {
  var map = keys.reduce(function (m, key) {
    m[key] = true;
    return m;
  }, {});
  var rest = {};
  var picked = {};
  Object.keys(obj).forEach(function (key) {
    if (map[key]) {
      picked[key] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  return [picked, rest];
}
export function omit(obj, keys) {
  return pick(obj, keys)[1];
}
export var UNIQUE_KEY_REF = Symbol('unique_key_ref');
export function getUniqueKey(obj) {
  if (typeof obj !== 'function' && _typeof(obj) !== 'object') {
    return "".concat(_typeof(obj), " - ").concat(String(obj));
  }

  if (obj == null) {
    return String(obj) + ' - ' + String(null);
  }

  var map = obj;

  if (UNIQUE_KEY_REF in map) {
    return map[UNIQUE_KEY_REF];
  }

  var id = "".concat(_typeof(obj), " - ").concat(guid());
  Object.defineProperty(obj, UNIQUE_KEY_REF, {
    value: id,
    writable: false,
    enumerable: false,
    configurable: false
  });
  return id;
}
export function keyMirror(str) {
  var splitChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (typeof str === 'number') {
    str = String(str);
  }

  if (typeof str === 'string') {
    str = str.split(splitChar);
  }

  return str.reduce(function (map, char) {
    map[String(char)] = String(char);
    return map;
  }, {});
}
export function getObjectProperty(obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (obj == null) {
    return obj;
  }

  for (var i = index; i < keys.length; i++) {
    obj = obj[keys[i]];

    if (obj == null) {
      return obj;
    }
  }

  return obj;
}
export function setObjectProperty(obj, value, keys) {
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (obj == null || _typeof(obj) !== 'object') {
    return false;
  }

  for (var i = index; i < keys.length - 1; i++) {
    obj = obj[keys[i]];

    if (obj == null || _typeof(obj) !== 'object') {
      return false;
    }
  }

  obj[keys[keys.length - 1]] = value;
  return true;
}
export function padding(str, len) {
  var padStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  var pad = '';

  for (var i = 0; i < 4; i++) {
    pad += padStr;
  }

  return (pad + str).slice(-len);
}
export function getKeys(obj) {
  return Object.keys(obj);
}
export function camelCase(str) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return str.replace(new RegExp('[' + prefix + ']' + '(.)', 'gi'), function (all, letter) {
    return letter.toUpperCase();
  });
}
export function pascalCase(str) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  str = camelCase(str, prefix);
  return "".concat(str[0].toUpperCase()).concat(str.slice(1));
}
export function camelize(target) {
  return camelCase(target, '-');
}
export function isWindow(obj) {
  return obj != null && obj.window === window;
}
export function uniqueString(arr) {
  var obj = {};
  arr.forEach(function (key) {
    return obj[key] = true;
  });
  return Object.keys(obj);
}
export function uniqueNumber(arr) {
  return uniqueString(arr).map(function (item) {
    return Number(item);
  });
}
export function shallowMerge(source1, source2) {
  var res = {};
  [source1, source2].forEach(function (item) {
    getKeys(item).forEach(function (key) {
      var value = item[key];

      if (value === undefined) {
        return;
      }

      res[key] = value;
    });
  });
  return res;
}
export function shallowArray(first, second, compareFn) {
  if (first.length !== second.length) {
    return false;
  }

  return shallowEqual(first.sort(compareFn), second.sort(compareFn));
}
export function mixin(Base) {
  var obj = Base.prototype;

  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  args.forEach(function (target) {
    var prototype = target.prototype;
    var descriptor = Object.getOwnPropertyDescriptors(prototype);
    Object.keys(descriptor).forEach(function (key) {
      Object.defineProperty(obj, key, descriptor[key]);
    });
  });
}
export function createMap(list, getKey) {
  var result = {};
  list.forEach(function (item, i) {
    var key = getKey ? getKey(item) : String(item);
    result[key] = {
      item: item,
      index: i
    };
  });
  return result;
}
export function isKorean(text) {
  var reg = /((\uAC00-\uD7AF)|(\u3130-\u318F))+/gi;
  return reg.test(text);
}
export function format(source, opts) {
  opts = opts || {};
  return source && source.replace(/\${(.+?)}/g, function (match, key) {
    var names = key.split('.');
    var replacer = opts;

    var _iterator = _createForOfIteratorHelper(names),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var name = _step.value;

        if (_typeof(replacer) !== 'object' || replacer == null) {
          break;
        }

        replacer = replacer[name];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return replacer == null ? '' : String(replacer);
  });
}